<template>
    <div>
      <div style="height: 10px;"></div>
      <div class="main contentWidth boxShadow">
        <div class="flex tabs-content">
            <Tabs :list="list" />
        </div>
        
        <JobCard></JobCard>
        <JobCard></JobCard>
        <JobCard></JobCard>

        <!-- <pagination
            :total="pagination.totalRow"
            v-model="conditions.pageIndex"
            v-if="pagination.totalRow>0 && !loading"
            @change="pageChange">
        </pagination>
        <prompt v-if="jobs.length < 1 && !loading"></prompt> -->
      </div>
      
    </div>
  </template>
  
  <script>
  import JobCard from './components/jobCard.vue';
  import Tabs from './components/tabs.vue';
  export default {
    data() {
      return {
        list:[
            {id:1,name:'全部'},
            {id:2,name:'待处理'},
            {id:3,name:'已接受'},
            {id:4,name:'已拒绝'}
        ]
      };
    },
    components:{JobCard,Tabs},
  
    computed: {
     
    }
  };
  </script>
  
  <style lang="less" scoped>
  @mianColor:#287CF3;
  @whiteColor:#fff;
  @mainFontCol:rgba(0,0,0,0.85);
  @secondfontCol:rgba(0,0,0,0.5);
  @yellowColor:#FF8A16;
  .main{
    padding: 20px;
    background: @whiteColor;
    margin-top: 20px;
    .tabs-content{
        border-bottom: 1px solid #EBEBEB;
        padding-bottom: 8px;
    }
  }
  
  </style>
  